<template>
    <Card />
</template>

<script>
import resourceMixin from '@/mixins/resourceMixin';

export default {
    name: 'MeasureEdit',
    mixins: [resourceMixin('measures')],
};
</script>

<style></style>
